'use strict';

var util = require('../../util/property-util');

module.exports = /*@ngInject*/ ["$log", "GoogleMapsFactory", "$compile", function mapReferenceareaOverlay($log, GoogleMapsFactory, $compile) {
    return {
        restrict: 'EA',
        transclude: true,
        scope: {
            ngMap: '=',
            projectId: '=',
            showLegend: '=',
            editable: '='
        },

        template: [
            ''
        ].join(''),

        link: function ($scope, $element, $attrs) {
            $scope.legend = [];         // model for the legend
            var drawingManager;         // drawing manager (toolkit to draw on the map)
            var polygonInfowindow;      // the currently shown polygon infowindow
            var revertablePolygonPath;  // contains the path of the polygon that is being edited (used for reverting)
            $scope.selectedPolygon;     // the currently selected polygon (used for edit, delete, etc.)
            $scope.description = "";    // description in the infowindow (for custom ref areas in editing mode)
            var referenceAreas = {
                waypoints: [],          // contains an array of waypoints (google map polygons)
                drawings: [],           // contains an array of custom drawings (google maps polygons)
                depots: []
            };

            var activated = false;      // set to true when we activated the fetch function (prevents from executing multiple times)

            $scope.$watch('ngMap', function () {
                if (verifyParameters()) {
                    activated = true;
                    init();
                }
            }, false);
            $scope.$watch('projectId', function () {
                if (verifyParameters()) {
                    activated = true;
                    init();
                }
            }, false);
            $scope.$watch('showLegend', function () {
            }, true);
            $scope.$watch('editable', function (edit) {
                if (activated) {
                    setEditableMode(edit);
                }
            }, true);

            /**
             * returns true when all parameters that are needed to load the data are valid
             * @returns {boolean}
             */
            var verifyParameters = function () {
                if (util.isDefined($scope.ngMap) &&
                    $scope.projectId !== undefined &&
                    !activated) {
                    return true;
                } else {
                    return false;
                }
            };
            var init = function () {
                fetchAndDrawReferenceAreas($scope.projectId, $scope.ngMap);
                addDrawingManagerToMap($scope.ngMap, $scope.editable);
            };

            /**
             * Sets the editable mode of the google maps custom drawings
             *  - enables you to edit existing custom drawings.
             *  - enables you to draw new drawings.
             * @param editable
             */
            var setEditableMode = function (editable) {
                if (editable) {
                    if (util.isDefined(drawingManager) && util.isDefined(referenceAreas.drawings) && referenceAreas.drawings.length !== 0) {
                        drawingManager.setOptions({drawingControl: true});
                        // add triggers to all
                        referenceAreas.drawings.forEach(function (polygon) {
                            google.maps.event.clearInstanceListeners(polygon);
                            // Add a listener for the click event.
                            google.maps.event.addListener(polygon, "click", function (event) {
                                polygonOnClickEvent(polygon, event);
                            });
                        });
                    }
                } else {
                    if (util.isDefined(drawingManager) && util.isDefined(referenceAreas.drawings) && referenceAreas.drawings.length !== 0) {
                        drawingManager.setOptions({drawingControl: false});
                        deselectPolygon();
                        // create and show the infowindow
                        if (util.isDefined(polygonInfowindow)) {
                            polygonInfowindow.setMap(null);
                        }
                        referenceAreas.drawings.forEach(function (polygon) {
                            // Remove listeners from the polygon
                            google.maps.event.clearInstanceListeners(polygon);
                        });
                        addDescriptionInfoWindowToReferenceAreas(referenceAreas.drawings, "Custom");
                    }
                }
            };

            /**
             * This function gets the referenceAreas from the database, adds them to the map and creates a legend item
             */
            var fetchAndDrawReferenceAreas = function (projectId, map) {

                if (projectId !== undefined) {
                    // todo: we don't always want all referenceAreas?
                    // add the waypoints
                    referenceAreas.waypoints = GoogleMapsFactory.getWaypoints(projectId);
                    referenceAreas.waypoints.then(function (data) {
                        referenceAreas.waypoints = data;
                        addDescriptionInfoWindowToReferenceAreas(referenceAreas.waypoints, "Waypoint");
                        GoogleMapsFactory.addObjectsToMap(map, data);
                        $scope.legend.push(GoogleMapsFactory.getLegendItem("waypoints"));
                    });
                    // add the waypoints
                    referenceAreas.depots = GoogleMapsFactory.getDepotZones(projectId);
                    referenceAreas.depots.then(function (data) {
                        referenceAreas.depots = data;
                        addDescriptionInfoWindowToReferenceAreas(referenceAreas.depots, "Depot");
                        GoogleMapsFactory.addObjectsToMap(map, data);
                        $scope.legend.push(GoogleMapsFactory.getLegendItem("depots"));
                    });
                    // add the custom reference areas
                    referenceAreas.drawings = GoogleMapsFactory.getCustomReferenceAreas(projectId);
                    referenceAreas.drawings.then(function (data) {
                        referenceAreas.drawings = data;
                        GoogleMapsFactory.addObjectsToMap(map, data);
                        $scope.legend.push(GoogleMapsFactory.getLegendItem("drawings"));
                        if (util.isDefined($scope.editable)) {
                            setEditableMode($scope.editable);
                        }
                    });
                }
            };

            /**
             * Adds the drawing manager to the map.
             * @param map       {google.maps.Map} object
             * @param visible   visibility of drawing manager. Defaults to false.
             */
            var addDrawingManagerToMap = function (map, visible) {
                visible = util.isDefined(visible) ? visible : false;
                drawingManager = GoogleMapsFactory.addDrawingOptions(map, overlayComplete, visible);
                drawingManager.setMap(map);
            };

            /**
             * This function is activated when the user drawing (polygon) is complete (eg. all dots are connected)
             * The user is required to click on the designated save button in order to persist the polygon to both the database & the UI
             *  - we add a click listener to the new polygon. This allows us to open an infowindow when the user clicks on the polygon
             *  - we simulate the click event to open the infowindow and set the polygon in 'editing' mode. (we need to $apply for the ui to update properly)
             *  - we reset the selected drawing tool to the default 'drag-hand'
             * @param polygon   {google.maps.Polygon}
             */
            var overlayComplete = function (polygon) {
                // we drew a new polygon!

                // Add a listener for the click event.
                google.maps.event.addListener(polygon, "click", function (event) {
                    polygonOnClickEvent(polygon, event);
                });

                // reset drawingtool to drag-hand
                GoogleMapsFactory.resetDrawingTool(drawingManager);

                // set this polygon in editable mode with infowindow
                polygonOnClickEvent(polygon);
                $scope.editPolygon();
                $scope.$apply();
            };

            /**
             * This function is triggered when a polygon is clicked.
             * Flow:
             *  - if another polygon was selected when clicking the current polygon, we first deselect the previous polygon.
             *      this ensures that variables used to mark the selected polygon are cleared, and the other infowindow is closed
             *  - we set the current polygon to the 'selectedPolygon' variable, and add a property 'selected:true'.
             *      (this is used to find the polygon in the customMarkers array)
             *  - next we backup the path (coordinates) of the polygon. This allows us to revert any changes made to the path later on.
             *  - a polygon infowindow is created (contains edit, save, delete and undo buttons) and shown
             *  - we add a closeclick listener to the infowindow which deselects the polygon when the infowindow is closed.
             * @param polygon
             * @param event
             */
            var polygonOnClickEvent = function (polygon, event) {
                // set the selectedPolygon to the current polygon
                if (util.isDefined($scope.selectedPolygon) && polygon != $scope.selectedPolygon) {
                    deselectPolygon();
                }
                $scope.selectedPolygon = polygon;

                var array = [];
                if (!util.isDefined($scope.selectedPolygon.area)) {
                    $scope.selectedPolygon.getPath().forEach(function (latLng) {
                        array.push([latLng.lat(), latLng.lng()]);
                    });
                } else {
                    $scope.selectedPolygon.area.positions.forEach(function (position) {
                        "use strict";
                        array.push([position.latitude, position.longitude]);
                    });
                }
                $scope.jsonString = JSON.stringify(array);

                //this property will be used to delete the polygon from the array (if needed)
                $scope.selectedPolygon.selected = true;

                polygonInfowindow = addCustomDrawingInfowindow(polygon);

                google.maps.event.addListener(polygonInfowindow, "closeclick", deselectPolygon);
                polygonInfowindow.open($scope.ngMap);
            };

            var addCustomDrawingInfowindow = function (polygon) {
                // create and show the infowindow
                if (util.isDefined(polygonInfowindow)) {
                    polygonInfowindow.setMap(null);
                }
                return createInfoWindowForCustomDrawing(polygon, $scope, "editPolygon", "savePolygon", "deletePolygon", "discardChangesPolygon", "exportPolygon");

            };
            /**
             * Creates and returns an infowindow for the customdrawing {google.maps.polygon} object
             * @param polygon {google.maps.polygon} object for which to create the infowindow
             * @param editFunctionName
             * @param deleteFunctionName
             * @returns {google.maps.InfoWindow}
             */
            var createInfoWindowForCustomDrawing = function (polygon, scope, editFunctionName, saveFunctionName, deleteFunctionName, discardFunctionName, exportFunctionName) {
                var infoWindow = new google.maps.InfoWindow({closeBoxURL: ""});

                // create contentstring
                var contentString = '<div><span class="h5">Custom Drawing</span><br/>';

                contentString += '<b>Description:</b>';
                contentString += '<div style="margin: 0px 0px 10px 10px">';
                contentString += '<span ng-show="!editingPolygon()"> {{selectedPolygon.description}} </span><br/>';
                contentString += '<textarea ng-show="editingPolygon()" ng-model="description" class="form-control" rows="3" style="resize: none;"></textarea>';

                contentString += '<div class="btn-group margin-top-10px" role="group">';
                contentString += '<button type="button" ng-disabled="editingPolygon()"  ng-click="' + editFunctionName + '()" class="btn btn-default"><span class="hover icon-right-margin fa fa-edit"></span>edit</button>';
                contentString += '<button type="button" ng-disabled="!editingPolygon()"  ng-click="' + saveFunctionName + '()" class="btn btn-default"><span class="hover icon-right-margin fa fa-save"></span>save</button>';
                contentString += '<button type="button" ng-disabled="!editingPolygon()"  ng-click="' + discardFunctionName + '()" class="btn btn-default"><span class="hover icon-right-margin fa fa-undo"></span>undo</button>';
                contentString += '<button type="button" ng-disabled="!editingPolygon()"  ng-click="' + deleteFunctionName + '()" class="btn btn-default d9534f"><span class="hover icon-right-margin fa fa-remove"></span>remove</button>';
                contentString += '<button type="button" class="btn btn-default" clipboard text="jsonString" ><i class="fa fa-clipboard"></i></button>';

                contentString += '<span ng-show="errorMsg != undefined" class="col-md-12 alert alert-warning margin-top-10px margin-bottom-0px">{{errorMsg}}</span>'

                contentString += '</div>';
                contentString += '</div>';// ends div button group
                contentString += '</div>';// ends enclosing div container

                var compiledContentString = $compile(contentString)(scope);

                infoWindow.setContent(compiledContentString[0]);
                scope.$apply(); // this apply is needed to trigger the ng-shows in the html content

                // sets the location of the infowindow to the most northen point in the polygon
                infoWindow.setPosition(getNorthernmostLatLngFromPath(polygon.getPath()));
                return infoWindow;
            };

            /**
             * Adds a description infowindow to all referencesAreas
             * @param referenceAreas    array of referenceAreas
             * @param title             title for the infowindow
             */
            var addDescriptionInfoWindowToReferenceAreas = function (referenceAreas, title) {
            };

            /**
             * Returns the most northern LatLng position in the path
             * @param path  array of LatLng coordinates
             * @returns {*}
             */
            var getNorthernmostLatLngFromPath = function (path) {
                var point;
                path.forEach(function (latLng) {
                    if (!util.isDefined(point)) {
                        point = latLng;
                    } else {
                        point = latLng.lat() > point.lat() ? latLng : point;
                    }
                });
                return point;
            };


            /**
             * The legend executes this function when the user clicks on an item from the legend
             * The item that is clicked toggles between visible and hidden (add or remove map from objects)
             * @param name      the name of the legend item that is clicked (it MUST correspond to a property of the referenceArea)
             * @param visible   should the item be shown (true) or hidden (false)
             */
            $scope.toggleLegendItem = function (name, visible) {
                if (util.isDefined(referenceAreas[name])) {
                    if (visible) {
                        GoogleMapsFactory.addObjectsToMap($scope.ngMap, referenceAreas[name]);
                    } else {
                        GoogleMapsFactory.removeObjectsFromMap(referenceAreas[name]);
                    }
                }
            };

            /**
             * Deselects a polygon
             *  - if this was a new polygon (not saved): simply delete it entirely
             *  - if this was an existing polygon: exit editing mode and revert to backupPath
             */
            var deselectPolygon = function () {
                if (util.isDefined($scope.selectedPolygon)) {
                    var index = util.getIndex(referenceAreas.drawings, "selected", true);
                    if (index === -1) {
                        // previous polygon was not saved, delete it!
                        // set map to null & hide infowindow

                        $scope.deletePolygon();
                    } else {
                        // previous polygon was saved, just discard changes
                        $scope.selectedPolygon.selected = false;
                        if ($scope.editingPolygon()) {
                            revertSelectedPolygon();
                        }
                    }

                    $scope.selectedPolygon = undefined;
                }
            };
            /**
             * Reverts changes made to the selected polygon, and exits the polygon's editing mode
             */

            var revertSelectedPolygon = function () {
                if (util.isDefined(revertablePolygonPath)) {
                    $scope.selectedPolygon.setPath(revertablePolygonPath);
                } else {
                    $log.warn("should revert changes, but no backup found");
                }
                // after reverting changes, exit editing mode
                exitPolygonEditingMode();
            };

            /**
             * Exits the polygon's editing mode and removes the polygon's backup path (used to revert)
             */
            var exitPolygonEditingMode = function () {
                if (util.isDefined($scope.selectedPolygon)) {
                    $scope.selectedPolygon.setEditable(false);
                    revertablePolygonPath = undefined;
                    $scope.errorMsg = undefined;
                }
            };

            /**
             * Sets the selected polygon in editing mode.
             * Also creates a copy of the polygon's path to be able to undo changes later on (if needed).
             *
             * Activated by the editbutton in the infowindow
             */
            $scope.editPolygon = function () {
                $scope.selectedPolygon.setEditable(true);
                // backup the path of the polygon, so we can revert any changes
                revertablePolygonPath = GoogleMapsFactory.getPathCopyFromPolygon($scope.selectedPolygon);
                $scope.description = $scope.selectedPolygon.description;
            };
            /**
             * Deletes a polygon.
             *  - if the polygon was saved to the database, we delete it from the database.
             *  - if it was a newly drawn polygon (not saved), simply remove it from the map
             *
             * Activated by delete button in the infowindow
             */
            $scope.deletePolygon = function () {
                var index = util.getIndex(referenceAreas.drawings, "selected", true);

                if (index !== -1) {
                    GoogleMapsFactory.customReferenceAreaCRUD($scope.selectedPolygon, $scope.projectId).delete();
                    referenceAreas.drawings.splice(index, 1);
                } else {
                    // this is a new polygon
                }
                exitPolygonEditingMode();
                $scope.selectedPolygon.setMap(null); // remove polygon from the map
                $scope.selectedPolygon = undefined;

                $scope.errorMsg = undefined;
                // hide the infowindow
                if (util.isDefined(polygonInfowindow)) {
                    polygonInfowindow.setMap(null);
                }
            };

            $scope.exportPolygon = function () {
                var array = [];

                $scope.selectedPolygon.area.positions.forEach(function (position) {
                    "use strict";
                    array.push([position.latitude, position.longitude]);
                });

                $scope.selectedPolygon.toggleExport = !$scope.selectedPolygon.toggleExport;
                $scope.selectedPolygon.exportDescription = angular.fromJson(array);

            };

            /**
             * Saves a polygon to the database and local storage
             *  - if the polygon was already persisted to the database: update the existing record
             *  - if the polygon was new: save a new record. (in the background the selectedPolygon gets an id generated by the database)
             *
             * Activated by save button in the infowindow
             */
            $scope.savePolygon = function () {
                $scope.selectedPolygon.description = $scope.description;
                var index = util.getIndex(referenceAreas.drawings, "selected", true);
                if (index === -1) {
                    var newPoly = GoogleMapsFactory.customReferenceAreaCRUD($scope.selectedPolygon, $scope.projectId).save();
                    newPoly.then(
                        function (data) {
                            referenceAreas.drawings.push($scope.selectedPolygon);
                            // after saving we exit editing mode
                            exitPolygonEditingMode();
                        },
                        function (errormsg) {
                            $scope.errorMsg = errormsg.statusText;
                        });

                } else {

                    var updatedPoly = GoogleMapsFactory.customReferenceAreaCRUD($scope.selectedPolygon, $scope.projectId).update();
                    updatedPoly.then(
                        function (data) {
                            // after saving we exit editing mode
                            exitPolygonEditingMode();
                        },
                        function (errormsg) {
                            $scope.errorMsg = errormsg.statusText;
                        });
                }

            };
            /**
             * revert changes, either undo changes or remove polygon
             */
            $scope.discardChangesPolygon = function () {
                var index = util.getIndex(referenceAreas.drawings, "selected", true);
                if (index === -1) {
                    $scope.deletePolygon();
                } else {
                    revertSelectedPolygon();

                }
            };
            /**
             * Returns true when a polygon is being edited
             * @returns {*}
             */
            $scope.editingPolygon = function () {
                return util.isDefined($scope.selectedPolygon) && $scope.selectedPolygon.getEditable();
            }
        }
    }
}];